export enum ContactPersonActionTypes {
    API_RESPONSE_SUCCESS = '@@contactPerson/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@contactPerson/API_RESPONSE_ERROR',

    ADD_CONTACT_PERSON = '@@contactPerson/ADD_CONTACT_PERSON',
    EDIT_CONTACT_PERSON = '@@contactPerson/EDIT_CONTACT_PERSON',
    GET_CONTACT_PERSON = '@@contactPerson/GET_CONTACT_PERSON',
    GET_CONTACT_PERSONS = '@@contactPerson/GET_CONTACT_PERSONS',
    RESET = '@@contactPerson/RESET',
    RESET_SUCCESS = '@@contactPerson/RESET_SUCCESS',
    RESET_ERROR = '@@contactPerson/RESET_ERROR',
}
